module.exports = __webpack_public_path__ + "static/media/arete-logo.5834f1d4.png";